import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetFeedbackCategories',
            headers: {},
            args: {},
            urlArgs: {},
        });
        return result;
    };
};
